import React, { useState, useEffect } from "react";
import Button from "../ui/Button";
import logo from "../../assets/inryde_logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Home", href: "#home" },
    { name: "About", href: "#about" },
    { name: "Services", href: "#services" },
    { name: "Contact Us", href: "#contactus" },
  ];

  const scrollToSection = (href) => {
    const goToSection = () => {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    // If user is NOT on homepage → navigate first
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        goToSection();
      }, 300);
    } else {
      goToSection();
    }

    setMobileMenuOpen(false);
  };

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 40,
        background: scrolled ? "rgba(255, 255, 255, 0.95)" : "transparent",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        boxShadow: scrolled ? "0 4px 20px rgba(0,0,0,0.1)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 20px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "80px",
          }}
        >
          {/* Logo */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("#home")}
          >
           <Link> <img
              src={logo}
              alt="InRyde Logo"
              style={{
                height: "250px",
                width: "auto",
                marginLeft: "-40px",
                objectFit: "contain",
              }}onClick={() => scrollToSection("#home")}
            /></Link>
          </div>

          {/* Desktop Nav */}
          <div style={{ display: "flex", alignItems: "center", gap: "32px" }}>
            <div
              style={{
                display: window.innerWidth < 1024 ? "none" : "flex",
                gap: "32px",
              }}
            >
              {navLinks.map((link) => (
                <span
                  key={link.name}
                  onClick={() => scrollToSection(link.href)}
                  style={{
                    color: scrolled ? "#1C1C1C" : "#000000",
                    fontWeight: "500",
                    cursor: "pointer",
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                >
                  {link.name}
                </span>
              ))}
            </div>

            {/* Desktop Get App Button */}
            <div
              style={{
                display: window.innerWidth < 1024 ? "none" : "block",
              }}
            >
       <Button
                onClick={() => scrollToSection("#download")}
                style={{
                  padding: "8px 0",
                  width: "100px",
                  textAlign: "center",
                  borderRadius: "40px",
                  fontSize: "13px",
                  fontWeight: "600",
                }}
              >
                🔥 Get App
              </Button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            style={{
              display: window.innerWidth >= 1024 ? "none" : "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "32px",
              height: "28px",
              position: "relative",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                height: "2px",
                width: "24px",
                background: scrolled ? "#000" : "#fff",
                borderRadius: "2px",
                position: "absolute",
                top: "6px",
                transition: "0.3s",
              }}
            />
            <span
              style={{
                height: "2px",
                width: "24px",
                background: scrolled ? "#000" : "#fff",
                borderRadius: "2px",
                position: "absolute",
                top: "13px",
                transition: "0.3s",
              }}
            />
            <span
              style={{
                height: "2px",
                width: "24px",
                background: scrolled ? "#000" : "#fff",
                borderRadius: "2px",
                position: "absolute",
                top: "20px",
                transition: "0.3s",
              }}
            />
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: mobileMenuOpen ? "0" : "-100%",
          width: "70%",
          height: "100vh",
          background: "white",
          boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
          transition: "left 0.3s ease",
          padding: "80px 24px",
          zIndex: 30,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {navLinks.map((link) => (
          <span
            key={link.name}
            onClick={() => scrollToSection(link.href)}
            style={{
              color: "#1C1C1C",
              fontWeight: "500",
              padding: "14px 0",
              fontSize: "16px",
              cursor: "pointer",
              borderBottom: "1px solid #f0f0f0",
              width: "100%",
            }}
          >
            {link.name}
          </span>
        ))}

        {/* Mobile Get App Button */}
        <div style={{ marginTop: "30px", width: "100px" }}>
          <Button
            onClick={() => scrollToSection("#download")}
            style={{
              width: "100%",
              padding: "8px 0",
              borderRadius: "40px",
              fontSize: "13px",
              fontWeight: "600",
              textAlign: "center",
            }}
          >
            🔥 Get App
          </Button>
        </div>
      </div>
    </nav>
  );
}
